// extracted by mini-css-extract-plugin
export default {"floating":"ImageWrapMenu_floating__5DsU5","inline":"ImageWrapMenu_inline__30Ajh","btn":"ImageWrapMenu_btn__HLFIz","btnActive":"ImageWrapMenu_btnActive__D6ADA"};